export const productZj = [
    {
        id: 'zj001',
        date: '2023-01-15',
        image: '/xxh/xx001.jpg',
        name: '汝阳县智慧停车场建设项目系统平台搭建设备采购造价咨询服务',
        shortDescription: `本项目主要内容为洛阳市汝阳县智慧停车场建设系统软件开发及硬件设备采购、综合布线、安防、监控以及机房建设项目，其中包含了智慧驾驶舱、AIOT 物联感知平台、智慧执法管理系统、GIS (地理信息系统)、传感器、服务器、存储设备、防火墙等。投资金额：约 1500 万元。`

    },
    {
        id: 'zj002',
        date: '2023-03-22',
        image: '/xxh/xx002.jpg',
        name: '洛阳市龙门石窟景区智能化票务系统更新升级项目造价咨询服务',
        shortDescription: `项目主要内容为对洛阳市龙门石窟景区智能票务系统部分功能进行增强开发，以及对部分硬件设备进行重新采购、项目综合布线、机房建设等。
        
        建设范围为景区范围内的 3 个售票中心、4 个检票景点、1 个管理中心、3 个票务机房、1 个线上云服务系统，以及和第三方票务平台进行系统对接。投资金额：约为 1000 万元。`
    },
    {
        id: 'zj003',

        date: '2023-05-10',
        image: '/xxh/xx003.jpg',
        name: '信息化档案管理系统造价咨询服务',
        shortDescription: '主要内容为某部 “信息化档案管理系统” 的软件开发费用计算及三年的系统运行维护费用计算，以及系统配套的国产硬件设施、配套数据库、中间件及基础软件的采购。投资金额：约 150 万元。'
    },
    {
        id: 'zj004',
        date: '2023-07-05',
        image: '/xxh/xx004.jpg',
        name: '洛阳市医保管理系统造价咨询服务',
        shortDescription: '主要内容为洛阳市医保反欺诈大数据应用监管系统，中间包含软件开发、硬件采购，HIS 系统、反欺诈系统、AI 模型、数据治理等。投资金额：约 800 万元。'
    },
    {
        id: 'zj005',
        date: '2023-09-18',
        image: '/xxh/xx005.jpg',
        name: '信阳市一体化政务服务平台（二期）项目造价咨询服务',
        shortDescription: '主要内容为构建信阳市政务服务 3 支撑平台 + 1 管理平台 + 4 服务渠道 + N 创新应用的 “信服办” 一体化政务服务体系及国产化适配迁移内容。投资金额：约 2600 万元。'
    },
    {
        id: 'zj006',
        date: '2023-11-24',
        image: '/xxh/xx006.jpg',
        name: '信阳市四水同治及城市供水信息化项目造价咨询服务',
        shortDescription: '主要内容为水情监测系统、水质监测系统、工情监视系统、管线阀门远程控制系统、管理中心监控室建设、管理中心会商室建设、通信网络建设、网络安全体系建设等八大系统及相关的硬件以及配套工程。投资金额：约 1000 万元。'
    },
    {
        id: 'zj007',
        date: '2024-01-30',
        image: '/xxh/xx007.jpg',
        name: '信阳市域社会治理数字化平台与警综平台对接及“平安建设”板块建设升级项目',
        shortDescription: '主要内容为实现信阳市域社会治理数字化平台与警综平台之间的数据对接任务，根据对接内容，对信阳市域社会治理数字化平台进行升级改造、梳理对接警综平台事项，与市域社会治理数字化平台事项清单对接映射，支撑市域社会治理数字化平台与警综平台的业务协同。投资金额：约 300 万元。'
    },
    {
        id: 'zj008',
        date: '2024-03-12',
        image: '/xxh/xx008.jpg',
        name: '新安县“智慧新安”一期及“雪亮工程”维修维护项目',
        shortDescription: '主要内容为 “智慧新安” 一期及 “雪亮工程” 的基础设施、硬件及软硬件一设备、网络安全设备、前端监控的维护，“智慧新安” 一期机房硬件、网络安全新增设备、摄像机的采购，监控地埋电缆维修费及 “雪亮工程” 平台升级、光纤线路租赁与运维、新安县公安局通讯调度系统维保等内容。投资金额：约 670 万元。'
    },
    {
        id: 'zj009',
        date: '2024-02-16',
        image: '/xxh/xx009.jpg',
        name: '信阳市公共安全视频监控建设联网应用项目',
        shortDescription: '主要内容为市综治中心建设，市公安局视频共享平台升级改造建设，市综治平台及20个行业部门平台建设，市主城区4000个一类监控点位建设，市本级无线应急系统建设，无人机系统建设及配套工程项目。投资金额：约19700万元。'
    },

    {
        id: 'zj010',
        date: '2024-02-16',
        image: '/xxh/xx013.jpg',
        name: '信阳市浉河区紧密型医共体信息化平台建设项目',
        shortDescription: '主要建设内容为智慧医院信息化建设及紧密型医共体信息化建设，主要包括系统基础管理、电子票据管理、门诊诊疗服务、急诊诊疗服务、CDSS、智慧中医、智慧医养、院前急救、医共体一体化信息平台、医共体一体化业务协同、医共体一体化运营管理等。投资金额：约6000万元。'
    },

    {
        id: 'zj011',
        date: '2023-02-12',
        image: '/xxh/xx010.jpg',
        name: '宜阳开发区数字化转型升级智慧产业园建设项目（一期）',
        shortDescription: '本项目主要建设内容为指挥中心设备升级改造，融合通信系统、网络安全系统、产业地图、产业图谱、企业运营分析，产业分析引擎、数字招商平台等。投资金额：约3500万元。'
    },
    {
        id: 'zj012',
        date: '2022-04-19',
        image: '/xxh/xx011.jpg',
        name: '中共洛阳市城乡一体化示范区工委政法信访部示范区社会治安防控体系',
        shortDescription: '主要内容为基础设施、机房硬件、网络安全设备、云存储扩容、视频平台扩容、车辆数据化结构应用扩容、大数据结构化应用、摄像机的采购，新建监控杆及管线工程等内容。投资金额：约为2698.19万元。'
    }
]